import React, { useEffect } from 'react';
import { countries } from 'countries-list';
import { create } from 'zustand';

import { useUserGeolocalization } from '#hooks/index';

import styles from './index.module.scss';
import { IconDown } from './icons';

export const useStore = create(set => ({
  selectedCountry: { code: 'PE', name: 'Peru' },
  phone: '51',

  setSelectedCountry: country => set({ selectedCountry: country }),
  setPhone: phone => set({ phone: phone })
}));

const InputPhone = ({ register, clearErrors, setValue }) => {
  const { data: geo } = useUserGeolocalization();
  const {
 selectedCountry, phone, setSelectedCountry, setPhone 
} = useStore();

  const countryList = Object.entries(countries).map(([code, { name, phone }]) => ({
    code,
    name,
    phone
  }));

  const handleCountryChange = event => {
    const selectedValue = event.target.value;

    // set selected country to new country
    const newSelectedCountry = countryList.find(
      country => country.code === selectedValue
    );
    setSelectedCountry(newSelectedCountry);

    // set phone number to new country phone code
    const newCountryPhone = newSelectedCountry?.phone;
    setPhone(newCountryPhone);
  };

  const handlePhoneChange = event => {
    const phoneValue = event.target.value;
    setPhone(phoneValue);
    setValue('phone', phoneValue);
    if (phoneValue?.length >= 6) {
      clearErrors('phone');
    }
  };

  useEffect(() => {
    if (geo) {
      const newSelectedCountry = countryList.find(
        country => country.code === geo.countryCode
      );
      setSelectedCountry(newSelectedCountry);

      const newCountryPhone = newSelectedCountry?.phone;
      setPhone(newCountryPhone);
    }
  }, [geo]);

  return (
    <div className={styles.container}>
      {/* Countries */}
      <div className={styles.countries}>
        <select
          className={styles.trigger}
          onChange={handleCountryChange}
          value={selectedCountry.code}
        >
          {countryList.map((country, idx) => (
            <option key={idx} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>

        <div className={styles.arrow}>
          <IconDown />
        </div>
      </div>
      {/* Phone Number */}
      <input
        className={styles.number}
        value={phone}
        onChange={handlePhoneChange}
        {...register('phone', {required: 'El número de teléfono es un campo obligatorio'})}
      />
    </div>
  );
};

export default InputPhone;
